<template>
  <v-container class="forbidden">
    <v-card flat class="forbidden__content">
      <h1 class="mb-4">{{ $t('forbidden.title') }}</h1>

      <p>
        <b>{{ $t('forbidden.text1') }}</b>
      </p>
      <p v-html="$t('forbidden.text2')">
        
      </p>
      <p>{{ $t('forbidden.text3') }}</p>

      <div class="d-flex align-items justify-end mt-8">
        <ActionButton :width="'140px'" :block="false" actionIcon="$sl-arrow-left" @click="$router.push('/')"
          >{{ $t('notfound.button') }}</ActionButton
        >
      </div>
    </v-card>
  </v-container>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton'
// @group Common
// NotFound component
export default {
  name: 'Forbidden',
  components: {
    ActionButton
  }
}
</script>

<style lang="scss" scoped>
.forbidden {
  width: 100%;
  height: 100%;
  position: relative;

  &__content {
    width: 90%;
    max-width: 600px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>